import {Component, OnInit} from '@angular/core';
import {AppSettingsService} from '../../../services/app-settings.service';
import {Router} from '@angular/router';
import {MobileInsuranceService} from '../../../services/mobile-insurance.service';
import {StaticMethods, Response} from '../../../model/GeneralModels';
import {AuthService} from '../../../services/auth.service';
import {MobileStaticMethods} from '../../../model/MobileInsuranceModels';

@Component({
  selector: 'app-new-request-confirmation',
  templateUrl: './new-request-confirmation.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class NewRequestConfirmationComponent implements OnInit {
  viewList: any = {};
  formsData: any = {};
  icon: string;
  translation: any = {};

  constructor(
    private services: MobileInsuranceService,
    public settings: AppSettingsService,
    private router: Router,
    private authService: AuthService
  ) {
  }

  ngOnInit() {
    if (StaticMethods.checkState(this.router, ['formsData', 'viewList', 'translation'], '/mobile/basic-information')) {
      this.formsData = history.state.formsData;
      this.viewList = history.state.viewList;
      this.translation = history.state.translation;
      switch (this.viewList.deviceType) {
        case 'لپ تاپ':
          this.icon = 'ico-smartphone-outline';
          break;
        case 'تبلت':
          this.icon = 'ico-smartphone-outline';
          break;
        default:
          this.icon = 'ico-smartphone-outline';
          break;
      }
    }
  }

  goNext() {
    if (this.authService.decode() && this.authService.decode().Role === 'user') {
      this.services.createRequest(this.formsData).subscribe((response: Response) => {
        if (response.success) {
          this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
          this.router.navigate(['mobile/details'], {state: {
            requestID: response.data, icon: MobileStaticMethods.getIcon(this.viewList.deviceType)
          }});
        }
      });
    } else {
      this.router.navigate(['login'],
        {queryParams: {returnUrl: 'mobile/confirmation'}, state: history.state}
      );
    }
  }
}
